import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Copyright from '@/components/Copyright'
import layoutMain from '@/components/LayoutMain'
import albumPage from '@/components/AlbumPage'
import discoverImgPage from '@/components/DiscoverImgPage'
import discoverMp4Page from '@/components/DiscoverMp4Page'
import imagePage from '@/components/ImagePage'
import mainPage from '@/components/MainPage'
import albumPageDetail from '@/components/AlbumPageDetail'
import detailImgPage from '@/components/DetailImgPage'
import detailMp4Page from '@/components/DetailMp4Page'
import uploadPage from '@/components/UploadPage'
import dynamicWallpaperPage from '@/components/DynamicWallpaperPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/hello',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/copyright',
      name: 'Copyright',
      component: Copyright
    },
    {
      path: '/',
      name: 'layoutMain',
      component: layoutMain,
      redirect: 'mainPage',
      children:[
        {
          path: 'dynamicWallpaperPage',
          name: 'dynamicWallpaperPage',
          component: dynamicWallpaperPage,
        },
        {
          path: 'uploadPage',
          name: 'uploadPage',
          component: uploadPage,
        },
        {
          path: 'albumPage',
          name: 'albumPage',
          component: albumPage,
        },
        {
          path: 'albumPageDetail',
          name: 'albumPageDetail',
          component: albumPageDetail
        },
        {
          path: 'detailImgPage',
          name: 'detailImgPage',
          component: detailImgPage
        },
        {
          path: 'detailMp4Page',
          name: 'detailMp4Page',
          component: detailMp4Page
        },
        {
          path: 'discoverMp4Page',
          name: 'discoverMp4Page',
          component: discoverMp4Page
        },
        {
          path: 'discoverImgPage',
          name: 'discoverImgPage',
          component: discoverImgPage
        },
        {
          path: 'imagePage',
          name: 'imagePage',
          component: imagePage
        },
        {
          path: 'mainPage',
          name: 'mainPage',
          component: mainPage
        }
      ]

    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js